module.exports = __webpack_public_path__ + "img/black_belt_center.38ac4517.gif";